// extracted by mini-css-extract-plugin
export var active = "_r4-1";
export var circle = "_r4-0";
export var completed = "_r4-2";
export var connector = "_r4-4";
export var connectorCompleted = "_r4-7";
export var connectorSpacer = "_r4-5";
export var iconStrokeOverride = "_r4-8";
export var labelContainer = "_r4-6";
export var pending = "_r4-3";